import { createHttpLink } from '@apollo/client';
import { HASURA_GRAPHQL_URI } from '~/constants';

const httpLink = createHttpLink({
    uri: HASURA_GRAPHQL_URI,
    credentials: 'include', // include cookies
});

export default httpLink;
